import { Component, OnInit } from '@angular/core';
import { AuthAPIService } from '../auth/auth.api.service';
import { IntercomService } from '@app/shared/utils/intercom.service';

@Component({
  selector: 'app-logout-component',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent implements OnInit {

  constructor(
    private authService: AuthAPIService,
    private intercomService: IntercomService,
  ) { }

  ngOnInit() {
    setTimeout(() => {
      this.intercomService.shutdown();
      this.authService.logout();
    }, 1000);
  }
}
